import {ModalComponents} from 'constants/Modals';

import Button from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import Icon from 'components/Icon/Icon';
import {toggleBeerOnTapACS} from 'features/beersManager/requestAC';
import TableRowAvatar from 'features/beersManager/shared/TableRowAvatar/TableRowAvatar';
import {setCheckedBeerAC} from 'features/beersManager/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import {PubBeer} from 'typescript/models/PubBeer';
import './ListBeersRow.scss';

interface IProps {
  beer: PubBeer;
}

const ListBeersRow = ({beer}: IProps) => {
  const dispatch = useSetGlobalState();

  const {managedPub} = useGlobalState((state) => state.managedPub);

  const {
    id,
    attributes: {beer_name, beer_logo, brewery_name, on_tap},
  } = beer;

  const toggleBeerOnTap = () => {
    if (!managedPub) return;
    dispatch(toggleBeerOnTapACS({pubId: managedPub.id, pubBeerId: id, on_tap: !on_tap}));
  };

  const handleEdit = () => {
    dispatch(setCheckedBeerAC({id: +id, name: beer_name, imageUrl: beer_logo || ''}));
    dispatch(setModalAC(ModalComponents.EDIT_BEER));
  };

  return (
    <>
      <td className="list-beers-row__icon-ceil">
        <div className="list-beers-row__icon">
          <Icon icon="drag" />
        </div>
      </td>
      <td className="list-beers-row__avatar-ceil">
        <TableRowAvatar name={beer_name} logo={beer_logo} breweryName={brewery_name} />
      </td>
      <td className="list-beers-row__actions-column">
        <Button variant="empty" disabled={!on_tap} title="edit beer" onClick={handleEdit}>
          <Icon icon="edit" />
        </Button>
      </td>
      <td>
        <div className="list-beers-row__checkbox">
          <Checkbox onChange={toggleBeerOnTap} title="toggle beer on tap" checked={on_tap} />
        </div>
      </td>
    </>
  );
};

export default ListBeersRow;
